module.exports = __webpack_public_path__ + "img/arrow-left.173620f0.svg";